/** 
 * 新官网地址
*/
export const EDU_WPS_CN_URL = 'https://edu.wps.cn/';